const BIS_ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
const SUBSCRIPTIONS_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';

class Klaviyo {
  constructor() {
    this.publicKey = __GLOBAL__.klaviyoKey;
  }

  /**
   * Subscribes a user to back-in-stock notifications.
   * @param {Object} params - The parameters for the subscription.
   * @param {string} params.email - The email address of the user.
   * @param {string} params.variant - The variant ID of the product.
   * @param {...Object} attributes - Additional attributes to include in the subscription.
   * @returns {Promise<Response>} The fetch response object.
   */
  async backInStockSubscribe({ email, variant, ...attributes }) {
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                ...attributes,
              },
            },
          },
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variant}`,
            },
          },
        },
      },
    };

    try {
      return await fetch(`${BIS_ENDPOINT}?company_id=${this.publicKey}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'REVISION': '2024-06-15',
          'Accept': 'application/json',
        },
        body: JSON.stringify(payload),
      });
    } catch (error) {
      throw error;
    }
  }

  /**
   * Subscribes a user to a list.
   * @param {Object} params - The parameters for the subscription.
   * @param {string} params.email - The email address of the user.
   * @param {string} params.list_id - The list ID to subscribe the user to.
   * @param {string} [params.source='Signup Form'] - The source of the subscription.
   * @param {...Object} attributes - Additional attributes to include in the subscription.
   * @returns {Promise<Response>} The fetch response object.
   */
  async subscribe({ email, list_id, source = 'Signup Form', ...attributes }) {
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                ...attributes,
              }
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: list_id,
            },
          },
        },
      },
    };

    try {
      return await fetch(`${SUBSCRIPTIONS_ENDPOINT}?company_id=${this.publicKey}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'REVISION': '2024-06-15',
          'Accept': 'application/json',
        },
        body: JSON.stringify(payload),
      });
    } catch (error) {
      throw error;
    }
  }
}

export default new Klaviyo();
